import React from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'components';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { getFTTBIsSocialInternetPopupOpen } from 'pages/Internet/store/selectors';
import { switchSocialInternetPopupVisible } from 'pages/Internet/store/actions/socialInternetActions';

import { PopupContentWrapper } from '../../components';
import { PopupButtonConnected, PopupDescriptionConnected, PopupTextConnected, PopupTitleConnected } from './connected';
import { getFTTBSocialInternetDataPopup } from '../../../../store/selectors';

const SocialInternetPopup = ({ isOpen, onClose }) => (
  <Popup opened={isOpen} onClose={onClose}>
    <PopupContentWrapper>
      <PopupTitleConnected />
      <PopupTextConnected />
      <PopupDescriptionConnected />

      <PopupButtonConnected />
    </PopupContentWrapper>
  </Popup>
);

SocialInternetPopup.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export const SocialInternetPopupConnected = compose(
  connect(
    (state) => ({
      isOpen: getFTTBIsSocialInternetPopupOpen(state),
      shouldRender: !!getFTTBSocialInternetDataPopup(state).title && !!getFTTBIsSocialInternetPopupOpen(state),
    }),
    {
      onClose: switchSocialInternetPopupVisible,
    },
  ),
  withRenderFlag,
)(SocialInternetPopup);
